import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { Illustration, type IllustrationName } from '../Illustration/Illustration';
import { illustrationOnlyStyle, illustrationStyle, tagStyle, textStyle } from './Tag.css';

type Props = ComponentPropsWithRef<'div'> &
  (
    | { illustration: IllustrationName; text: string }
    | { illustration: IllustrationName; text?: never }
    | { illustration?: never; text: string }
  );

export const Tag = ({ illustration, text, ...delegated }: Props) => {
  return (
    <div {...delegated} className={clsx(tagStyle, text === undefined && illustrationOnlyStyle, delegated.className)}>
      {illustration && <Illustration aria-hidden className={illustrationStyle} name={illustration} strokeWidth={2} />}

      {text && <span className={textStyle}>{text}</span>}
    </div>
  );
};
